import React, {Component} from 'react'
import {Form, Icon, Input} from 'antd';
import axios from 'axios'

const FormItem = Form.Item;

class NormalLoginForm extends Component {
  render() {
    return (
      <Form className='login-form'>
        <FormItem>
          <Input prefix={<Icon type='user' style={{color: '#fff'}}/>} placeholder='请输入登录名'/>
        </FormItem>
        <FormItem>
          <Input prefix={<Icon type='lock' style={{color: '#fff'}}/>} type='password'
                 placeholder='请输入密码'/>
        </FormItem>
        <FormItem>
          <Input type='button' onClick={this.handleSubmit} value={'登录'} className='login-form-button'/>
          <a ref='logo' href='#/homePage' style={{display: 'none'}}>登录</a>
        </FormItem>
        <FormItem className='login-btn-box'>
          <a href='#'>忘记密码?</a>
          <div className='a-box'>
            <a className='a-btn' href='#'>免费登录</a>
            <a className='a-btn' href='#/register'>用户注册</a>
          </div>
        </FormItem>
      </Form>
    );
  }

  handleSubmit = (e) => {
    let that = this;
    e.preventDefault();
    // axios.get('api/login.json', {
    //   params: 123
    // }).then(response => {
    //   if (response.data.success === 0) {
        that.refs.logo.click();
      // }
    // });
  }
}

const LoginForm = Form.create()(NormalLoginForm);

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/LoginForm.js